(function() {
    'use strict';

    angular
        .module('elogbooks.common.site-notes', []);
})();
